module.exports = __webpack_public_path__ + "static/media/van.918af8d1.svg";